import axios from 'axios'
import * as types from '../mutation-types'

import { createTheParametersOfTheUrl } from '../../plugins/helper'

const doToArrayObject = (projests) => {
  const term = []
  Object.keys(projests).forEach(key => {
    term.push({
      value: projests[key].id,
      text: projests[key].text,
      disabled: projests[key].disabled,
    })
  })

  return term
}

// state
export const state = {
  loading: true,
  projests: [],
  error: null,
  loadingProject: true,
  errorProject: null,
  project: {},
  loadingTimeDetail: true,
  detailsTime: [],
  averageTime: {},
  errorTimeDetail: null,
  loadingProgrammign: false,
  activeProgramming: [],
  errorProgramming: null,
  loadingPriorities: false,
  priorities: [],
  errorPriorities: null,
}

// mutations
export const mutations = {
  [types.GET_WEEKLY_BLOG_START] (state) {
    state.loading = true
    state.projests = []
    state.error = null
  },

  [types.GET_WEEKLY_BLOG_SUCCESS] (state, { data }) {
    state.loading = false
    state.projests = doToArrayObject(data)
    state.error = null
  },

  [types.GET_WEEKLY_BLOG_ERROR] (state, { error }) {
    state.loading = false
    state.projests = []
    state.error = error
  },

  [types.GET_PROJECT_START] (state) {
    state.loadingProject = true
    state.project = {}
    state.errorProject = null
  },

  [types.GET_PROJECT_SUCCESS] (state, { data }) {
    state.loadingProject = false
    state.project = data
    state.errorProject = null
  },

  [types.GET_PROJECT_ERROR] (state, { error }) {
    state.loadingProject = false
    state.project = {}
    state.errorProject = error
  },

  [types.GET_TIME_DETAIL_START] (state) {
    state.loadingTimeDetail = true
    state.detailsTime = []
    state.averageTime = {}
    state.errorTimeDetail = null
  },

  [types.GET_TIME_DETAIL_SUCCESS] (state, { data }) {
    state.loadingTimeDetail = false
    state.detailsTime = data.data
    state.averageTime = data.average
    state.errorTimeDetail = null
  },

  [types.GET_TIME_DETAIL_ERROR] (state, { error }) {
    state.loadingTimeDetail = false
    state.detailsTime = []
    state.averageTime = {}
    state.errorTimeDetail = error
  },

  [types.GET_PROGRAMMING_START] (state) {
    state.loadingProgramming = false
    state.activeProgramming = []
    state.errorProgramming = null
  },

  [types.GET_PROGRAMMING_SUCCESS] (state, { data }) {
    state.loadingProgramming = false
    state.activeProgramming = data.data
    state.errorProgramming = null
  },

  [types.GET_PROGRAMMING_ERROR] (state, { error }) {
    state.loadingProgramming = false
    state.activeProgramming = []
    state.errorProgramming = error
  },

  [types.GET_PRIORITIES_START] (state) {
    state.loadingPriorities = false
    state.priorities = []
    state.errorPriorities = null
  },

  [types.GET_PRIORITIES_SUCCESS] (state, { data }) {
    state.loadingPriorities = false
    state.priorities = data.data
    state.errorPriorities = null
  },

  [types.GET_PRIORITIES_ERROR] (state, { error }) {
    state.loadingPriorities = false
    state.priorities = []
    state.errorPriorities = error
  },
}

export const actions = {
  async getProjects ({ commit }, payload) {
    try {
      commit(types.GET_WEEKLY_BLOG_START)
      const href = createTheParametersOfTheUrl(payload)

      const { data } = await axios.get(`/api/projects/lists${href}`)

      commit(types.GET_WEEKLY_BLOG_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_WEEKLY_BLOG_ERROR, { error: e })
    }
  },

  async getProject ({ commit }, payload) {
    try {
      commit(types.GET_PROJECT_START)

      const { data } = await axios.get(`/api/projects/find/${payload}`)

      commit(types.GET_PROJECT_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_PROJECT_ERROR, { error: e })
    }
  },

  async getTimeDetail ({ commit }, payload) {
    try {
      commit(types.GET_TIME_DETAIL_START)

      const href = createTheParametersOfTheUrl(payload)
      const { data } = await axios.get(`/api/projects/weather${href}`)

      commit(types.GET_TIME_DETAIL_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_TIME_DETAIL_ERROR, { error: e })
    }
  },

  async getProgramming ({ commit }, { contractId, params }) {
    try {
      commit(types.GET_PROGRAMMING_START)

      const href = createTheParametersOfTheUrl(params)
      const { data } = await axios.get(`/api/programming/full_details/${contractId}${href}`)

      commit(types.GET_PROGRAMMING_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_PROGRAMMING_ERROR, { error: e })
    }
  },

  async getPriorities ({ commit }, { contractId, params }) {
    try {
      commit(types.GET_PRIORITIES_START)

      const href = createTheParametersOfTheUrl(params)
      const { data } = await axios.get(`/api/programming/priorities/${contractId}${href}`)

      commit(types.GET_PRIORITIES_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_PRIORITIES_ERROR, { error: e })
    }
  },
}

// getters
export const getters = {
  loadingProject: state => state.loading,
  projests: state => state.projests,
  errorProject: state => state.error,
  loadingFindProject: state => state.loadingProject,
  errorFindProject: state => state.errorProject,
  project: state => state.project,
  loadingTimeDetail: state => state.loadingTimeDetail,
  detailsTime: state => state.detailsTime,
  averageTime: state => state.averageTime,
  errorTimeDetail: state => state.errorTimeDetail,
  loadingProgramming: state => state.loadingProgramming,
  activeProgramming: state => state.activeProgramming,
  errorProgramming: state => state.errorProgramming,
  loadingPriorities: state => state.loadingPriorities,
  projectPriorities: state => state.priorities,
  errorPriorities: state => state.errorPriorities,
}
